import { Stack as MuiStack, StackProps as MuiStackProps, styled } from "@mui/material";

const StyledStack = styled(MuiStack)(() => ({
  // ... existing styles
}));

interface StackProps extends MuiStackProps {
  children: React.ReactNode;
}

export const Stack: React.FC<StackProps> = ({ children, ...props }) => {
  return <StyledStack {...props}>{children}</StyledStack>;
};

export default Stack;
